import { createContext, useContext } from "react";

export const LoaderUIContext = createContext({
  loading: false,
  replayLoader: () => {},
});

export function useLoaderUI() {
  return useContext(LoaderUIContext);
}
